// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"28d69bd4","466":"c7827335"}[chunkId] + ".chunk.js";
};